import { Hammer } from "lucide-react";
import { EmptyState } from "@/components/app/EmptyState";
import { PageHeader } from "@/components/app/PageHeader";
import type { AppRoute } from "@/lib/routes";

/** Stands in for a screen a later slice builds, so navigation, guards and the palette are real
 * from the start and the screen is added by supplying an element. */
export function PlaceholderPage({ route }: { route: AppRoute }) {
  return (
    <>
      <PageHeader title={route.label} description={route.purpose} />
      <div className="bg-card rounded-lg border">
        <EmptyState icon={Hammer} title="This screen is being built">
          It arrives in slice {route.slice} of the console plan. Until then, the rest of the console
          works as described in the help window.
        </EmptyState>
      </div>
    </>
  );
}
